import { analyticsClient } from '@databases/analytics';
import { InsertRowBelowIcon } from '@databases/icons';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import React from 'react';

import { Position } from '../../type.ts';
import { insertEntries } from '../actions/insert-entries.ts';
import { submenu } from '../state/submenu-state.ts';
import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types.ts';

/**
 * The config for adding an entry below a the currently selected cell(s).
 */
export const addEntryBelowMenuItem: MenuItemBuilder = ({
  capabilities: { canInsertContent },
  formatMessage,
  contentId
}) => {
  return {
    isEnabled: () => canInsertContent,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.ADD_ENTRY_BELOW,
      content: formatMessage(messages['entry-actions.add-below']),
      onClick: async () =>
        await insertEntries({
          position: Position.AFTER,
          client: analyticsClient,
          contentId,
          formatMessage
        }),
      onMouseEnter: submenu.close,
      shortcut: SHORTCUTS.ADD_ENTRY_BELOW,
      elemBefore: <InsertRowBelowIcon label="" />
    }
  };
};
